// src/Components/Marketplace/marketplaceUtils.js
export const formatINR = (amount) => {
  const n = Number(amount);
  if (Number.isNaN(n)) return "₹0";
  return `₹${n.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
};

export const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  const d = new Date(dateString);
  if (Number.isNaN(d.getTime())) return "N/A";
  return d.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

// Fixed set of common categories offered as filter chips — the backend `category`
// query param is free text, so these are just sensible, commonly-used values.
export const SERVICE_CATEGORIES = [
  "Taxi",
  "Airport Transfer",
  "Outstation",
  "Local",
  "Activities",
  "Guide",
  "Rentals",
];

export const TRIP_TYPE_LABELS = {
  AirportTransfer: "Airport Transfer",
  Local: "Local",
  Outstation: "Outstation",
  OneWay: "One Way",
  RoundTrip: "Round Trip",
  Hourly: "Hourly",
  FullDay: "Full Day",
};

export const STATUS_TONE = {
  Confirmed: "success",
  Completed: "brand",
  Cancelled: "warning",
  PendingPayment: "ink",
};

export const bookingTitle = (booking) =>
  booking?.packageId?.title || booking?.serviceId?.title || "Marketplace booking";
